module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', {
    ref: "trigger"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    ref: "popover",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "tooltip-arrow"
  }), _vm._v(" "), _c('div', {
    staticClass: "tooltip-inner"
  }, [_vm._t("content", [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22f73ce9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tooltip/tooltip.vue
// module id = 674
// module chunks = 85